import { render } from "./Certificate.vue?vue&type=template&id=c1b84e7e&scoped=true"
import script from "./Certificate.vue?vue&type=script&lang=js"
export * from "./Certificate.vue?vue&type=script&lang=js"

import "./Certificate.vue?vue&type=style&index=0&id=c1b84e7e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1b84e7e"]])

export default __exports__